import { registrarAcao } from '@/shared/utils/reportAction';

import type {
  ConsultaResponse,
  VerificacaoArquivoResponse,
} from '../types/autenticacaoPublica.types';

import { cadeiaNaoConfirmada } from './cadeiaDoDocumento';

/**
 * Conta no RUM cada vez que a página pública deixa de afirmar autenticidade por causa da cadeia
 * (core#1186): é o lado do visitante da métrica `autenticacao_publica_cadeia` do core. Só a via, a
 * família, o motivo e a versão — nada do código, do hash nem das partes (LGPD; o código abre a
 * página).
 *
 * @example registrarCadeiaNaoConfirmada('codigo', resultado)
 */
export function registrarCadeiaNaoConfirmada(
  via: 'codigo' | 'arquivo',
  resultado: ConsultaResponse | VerificacaoArquivoResponse,
): void {
  if (resultado.status !== 'VALID') return;
  const cadeia = cadeiaNaoConfirmada(resultado);
  if (!cadeia) return;
  registrarAcao('autenticacao_publica_cadeia_nao_confirmada', {
    via,
    tipo: resultado.tipo,
    motivo: cadeia.motivo,
    versao: cadeia.motivo === 'DIVERGENTE' ? cadeia.versao : null,
  });
}
